// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"79ffd3d1","254":"63901d60","422":"dc0b305c","447":"1e0debca","504":"5253f123","638":"f46f4a54","806":"91d544da","994":"e70050a3"}[chunkId] + ".chunk.js";
};